import Vue from 'vue';
import RequestSortType from '@/js/enums/RequestSortType';
import ROUTE_DEFAULTS from './defaults';
import { loadUserState, saveUserState } from './persist';

export const STATUS_CHIP_NAME = 'statusBar';

function defaultSort() {
    return { type: RequestSortType.DATE, reverse: true };
}

export function createRequestFilters() {
    const state = Vue.observable({
        method: null,
        ready: false,
        search: '',
        sort: defaultSort(),
        scope: null,
        statuses: null,
        panel: {},
        panelChips: [],
    });

    function persist() {
        saveUserState(state.method, {
            scope: state.scope,
            statuses: state.statuses,
            panel: state.panel,
            panelChips: state.panelChips,
        });
    }

    function init(method) {
        state.ready = false;
        state.method = method;
        state.search = '';
        state.sort = defaultSort();

        const saved = loadUserState(method);
        state.scope = saved && saved.scope !== undefined ? saved.scope : null;
        state.statuses = saved && saved.statuses !== undefined ? saved.statuses : null;
        state.panel = saved && saved.panel ? saved.panel : {};
        state.panelChips = saved && saved.panelChips ? saved.panelChips : [];

        state.ready = true;
    }

    function applyPanel(values, chips) {
        state.panel = { ...values };
        state.panelChips = [...chips];
        persist();
    }

    function removePanelFilter(name) {
        if (name === STATUS_CHIP_NAME) {
            state.statuses = null;
        } else {
            const panel = { ...state.panel };
            delete panel[name];
            state.panel = panel;
            state.panelChips = state.panelChips.filter((chip) => chip.name !== name);
        }
        persist();
    }

    function resetPanel() {
        state.panel = {};
        state.panelChips = [];
        state.statuses = null;
        persist();
    }

    function resetAll() {
        resetPanel();
    }

    function currentStatuses() {
        if (state.statuses !== null) return state.statuses;
        const defaults = ROUTE_DEFAULTS[state.method];
        return defaults && defaults.statuses ? defaults.statuses : [];
    }

    function toggleStatus(status) {
        const next = [...currentStatuses()];
        const index = next.indexOf(status);
        if (index === -1) {
            next.push(status);
        } else {
            next.splice(index, 1);
        }
        state.statuses = next;
        persist();
    }

    function clearStatuses() {
        state.statuses = [];
        persist();
    }

    function setStatusesFromPanel(statuses) {
        state.statuses = statuses.length ? statuses : null;
        persist();
    }

    function setScope(scope) {
        state.scope = scope || 'all';
        persist();
    }

    function setSort(sort) {
        state.sort = sort;
    }

    function setSearch(search) {
        state.search = search;
    }

    return {
        state,
        init,
        applyPanel,
        removePanelFilter,
        resetPanel,
        resetAll,
        toggleStatus,
        clearStatuses,
        setStatusesFromPanel,
        setScope,
        setSort,
        setSearch,
    };
}
